import * as React from 'react';
import { IEventRegistrationDetail } from '../../../Models/Registration/IEventRegistrationDetail';
import { RegistrationDetailView } from './RegistrationDetailView';
import * as Services from '../../../Services/Services';
import { useBoolean } from '@fluentui/react-hooks';
import { IStatusMessage } from '../../../Models/IStatusMessage';
import { IEventApi } from '../../../Services/API/Event/IEventApi';
import { FontIcon, mergeStyles, MessageBarType, Panel, PanelType, Stack, useTheme, Text, ProgressIndicator, MessageBar, DefaultButton } from '@fluentui/react';

interface IRegistrationDetailProps {
    isAdmin: boolean;
    eventId: number;
    isOpen: boolean;
    close: () => void;
}


export const RegistrationDetail: React.FunctionComponent<IRegistrationDetailProps> = (props) => {

    const [registration, setRegistration] = React.useState<IEventRegistrationDetail>();
    const [isLoading, setIsLoading] = useBoolean(false);
    const [statusMessage, setStatusMessage] = React.useState<IStatusMessage>()

    const theme = useTheme();
    const iconClass = mergeStyles({
        fontSize: 50,
        height: 50,
        width: 50,
        margin: '0 25px',
        color: theme.palette.themePrimary
    });

    const loadData= async (id: number) => {
        setIsLoading.setTrue();
        setStatusMessage(undefined);
        const eventTypeApi = Services.ServicesProvider.GetService<IEventApi>(Services.EventApi);
        const result = await eventTypeApi.getUsersEventRegistrationDetail(id);
        if (result.isSuccess && result.data) {
            setStatusMessage(undefined);
            setRegistration(result.data);
        }
        else {
            setStatusMessage({ message: result.message, type: MessageBarType.error });
        }
        setIsLoading.setFalse();
    }

    React.useEffect(() => {
        if (props.eventId > 0) {
            loadData(props.eventId);
        }
    }, [props.eventId])

    return (<>
        {props.isOpen ?
            <Panel
                isOpen={props.isOpen}
                onDismiss={props.close}
                type={PanelType.medium}
                closeButtonAriaLabel="Zavřít">
                <Stack>
                    <Stack horizontal>
                        <Stack horizontalAlign='end' styles={{ root: { width: 80 } }}>
                            <FontIcon iconName="Event" className={iconClass} />
                        </Stack>

                        <Stack horizontal verticalAlign="center">
                            <Text styles={{ root: { fontWeight: 600 } }} variant="xLarge">
                                {registration?.eventName}
                            </Text>
                        </Stack>
                    </Stack>
                    <RegistrationDetailView registration={registration} isLoading={isLoading} isAdmin={props.isAdmin} />
                    <Stack styles={{ root: { height: 10 } }}>
                        {isLoading ? <ProgressIndicator /> : null}
                    </Stack>

                    <Stack horizontal tokens={{ padding: 20, childrenGap: 15 }} horizontalAlign="center">                        
                        <DefaultButton onClick={props.close}>Zavřít</DefaultButton>
                    </Stack>
                    {statusMessage && statusMessage.message ? <MessageBar messageBarType={statusMessage.type}>{statusMessage.message}</MessageBar> : null}
                </Stack>
            </Panel> : null
        }
    </>)
}
